import { CampaignBlocks, CampaignTemplates } from "@kvix/shared";
import { AnimatedInstructorsBlock, AnimatedSessionsBlock, CommentBlock, CommentsBlock, CtaWithFeaturesBlock, CtaWithImgBlock, CtaWithTextBlock, FaqBlock, FeatureBlock, LoopVideoBlock } from "..";
import { AffiliateCtaWithImgBlock } from "../blocks/AffiliateCtaWithImgBlock";
import { AffiliateTemplate, DefaultTemplate, InstructorTemplate } from "../templates";
const campaignTemplateList = {
    [CampaignTemplates.DefaultTemplate]: DefaultTemplate,
    [CampaignTemplates.InstructorTemplate]: InstructorTemplate,
    [CampaignTemplates.AffiliateTemplate]: AffiliateTemplate
};
const campaignBlockList = {
    [CampaignBlocks.LoopVideoBlock]: LoopVideoBlock,
    [CampaignBlocks.CtaWithImgBlock]: CtaWithImgBlock,
    [CampaignBlocks.AffiliateCtaWithImgBlock]: AffiliateCtaWithImgBlock,
    [CampaignBlocks.CommentsBlock]: CommentsBlock,
    [CampaignBlocks.CommentBlock]: CommentBlock,
    [CampaignBlocks.AnimatedInstructorsBlock]: AnimatedInstructorsBlock,
    [CampaignBlocks.AnimatedSessionsBlock]: AnimatedSessionsBlock,
    [CampaignBlocks.CtaWithFeaturesBlock]: CtaWithFeaturesBlock,
    [CampaignBlocks.CtaWithTextBlock]: CtaWithTextBlock,
    [CampaignBlocks.FaqBlock]: FaqBlock,
    [CampaignBlocks.FeatureBlock]: FeatureBlock
};
export { campaignTemplateList, campaignBlockList };
//# sourceMappingURL=index.js.map